import React, { useEffect, useRef, useState} from 'react';
import { Drawer } from 'vaul';
import { fetchSingleParams } from '../../services/prompt';
import Spacing from '../Spacing';
import { adjustDateTime, exchangeDate, formatDate } from '../../helpers';

export default function PromptSingleViewModal(props) {
  const {
    account_id,
    location_id,
    openPromptViewId = null,
    activeModal = false,
    setActiveModal = () => {},
    previousScrollPosition = 0,
  } = props;

  const [data, setData] = useState([]);
  const dropdownRef = useRef(null);

  const loadData = async (account_id, location_id, speciality_prompt_id) => {
    try {
      const result = await fetchSingleParams(account_id, location_id, speciality_prompt_id);

      if(result){
        if(result?.data?.status === 'success'){
          setData(result?.data?.data);
        } else {
          console.log("🚀 ~ loadSinglePromptData ~ error:", result?.data?.message);
        }
      }
    } catch (error) {
      // console.log("🚀 ~ loadSinglePromptData ~ error:", error);
    }
  };

  useEffect(() => {
    loadData(account_id, location_id, openPromptViewId);
  }, [location_id, account_id, openPromptViewId]);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <>
      <div style={{ height: "100%" }} ref={dropdownRef}>
        <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
          <Drawer.Trigger className="docpro_single_patiant_modal_btn">
          </Drawer.Trigger>
          <Drawer.Portal>
            <Drawer.Overlay className="docpro_drawer_overlay"/>
            <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
              <Drawer.Title className="sr-only">Prompt Details</Drawer.Title>
              <Drawer.Description className="sr-only">View details of a prompt</Drawer.Description>
              <div className="docpro_modal_wrap docpro_style_1 docpro_modal_lg">
                <div className="docpro_modal" style={{ backgroundColor: '#F9F9FB' }}>
                  <div className="prompt_div">
                    <h2 className="docpro_fs_24 docpro_mb_0">
                      Speciality Prompt Details 
                      <span className='docpro_fs_12 docpro_tip_checkbox docpro_accent_color'>
                        {" "}{exchangeDate(formatDate(data?.updated_at))}
                        <span className="docpro_tip text-center">Last Modified <br /> {adjustDateTime(data?.updated_at)}</span>
                      </span>
                    </h2>
                    <Spacing lg="20" sm="20" />
                    {data?.length === 0 ? (
                      <div
                        style={{
                          height: "300px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Loading...
                      </div>
                    ) : (
                      <>
                        <div className="docpro_grid docpro_grid_gap_10 docpro_grid_col_2 input">
                          <div className="docpro_grid_item">
                            <p className="docpro_mb_0"><b>Practice: </b>{data?.practice_name}</p>
                          </div>
                          <div className="docpro_grid_item">
                            <p className="docpro_mb_0"><b>Location: </b>{data?.location_name}</p>
                          </div>
                          <div className="docpro_grid_item">
                            <p className="docpro_mb_0"><b>Speciality: </b>{data?.speciality_name}</p>
                          </div>
                          <div className="docpro_grid_item">
                            <p className="docpro_mb_0"><b>Model: </b>{data?.model}</p>
                          </div>
                        </div>
                        <Spacing lg="10" sm="10" />
                        <p className="docpro_mb_0 mb-1"><b>Details: </b><span className='docpro_accent_color'>{data?.prompt_file_url}</span></p>
                        <textarea
                          cols="30"
                          rows="8"
                          className="signout_textbox view_details"
                          value={data?.content}
                          readOnly
                        ></textarea>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Drawer.Content>
          </Drawer.Portal>
        </Drawer.Root>
      </div>
    </>
  );
}